import { useCaseService } from "@/hooks/useCaseService";
import { updateCasePhysicianInCache } from "@/hooks/useCases";
import type { UpdateCasePhysicianResponse } from "@/services/caseServiceV2.types";
import { useCallback } from "react";

export const useCasePhysician = () => {
  const caseService = useCaseService();

  // caseId is per-call rather than bound at hook level: the new-case flow only learns the
  // id after the case is created, which a render-time binding cannot express.
  const assignPhysician = useCallback(
    async (caseId: string, userId: string): Promise<UpdateCasePhysicianResponse> => {
      const updated = await caseService.updateCasePhysician(caseId, userId);
      updateCasePhysicianInCache(caseId, updated);
      return updated;
    },
    [caseService]
  );

  return { assignPhysician };
};
